<script setup>
    import { festivalJsonLd, serializeJsonLd } from '@/utils/seo';

    // The festival as a schema.org Event, so search can show its dates.
    // Title, description and share tags come from the default layout.
    useHead({
        script: [{ key: 'ld-json-festival', type: 'application/ld+json', innerHTML: serializeJsonLd(festivalJsonLd()) }],
    });
</script>

<template>
    <TemplatesHomePage />
</template>
